import { useNode } from "@craftjs/core";
import React, { useContext, useState } from "react";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  PencilActiveIcon,
  PaintIcon,
  SettingsActiveIcon,
  SettingsLightIcon,
  PhotoIcon,
} from "../../../assets/ui-icons";

import { OptionsInput, SpacerInput, TextInput } from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { APIProviderContext } from "../../api";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSTwitterSettings = () => {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const [isActive, setIsActive] = useState("general");

  const { url, align } = props;
  const { getTweet } = useContext(APIProviderContext);

  const General = () => {
    return (
      <>
        <div className="w-full rounded-[21px] py-5 bg-white flex flex-col">
          <SpacerInput ypadding={"0"}>
            <TextInput
              minLength={INPUT_LIMITS["outbound-link"].minlength}
              maxLength={INPUT_LIMITS["outbound-link"].maxlength}
              isResponsive={true}
              resetValue={undefined}
              value={url}
              onChange={(val) => {
                setProp((props) => {
                  props.url = val.target.value;
                });
              }}
              label={"Tweet URL"}
            />
            <button
              onClick={(e) => {
                if (!url) return;
                getTweet(url)
                  .then((res) => {
                    setProp((props) => {
                      props.tweet = JSON.stringify(res.data.Output.message);
                    });
                  })
                  .catch((error) => {
                    // console.log(error);
                  });
              }}
              className={`rounded-[21px] bg-ui-light-white outline-none w-fit p-2 px-3 text-sm mt-[-10px] hover:bg-ui-grey duration-300
            `}
            >
              Embed
            </button>
            {/* <RangeInput
              value={width}
              onChange={(val) => {
                setProp((props) => {
                  props.width = val+"%";
                });
              }}
              label={"Width"}
            />
            <RangeInput
              resetValue={undefined}
              value={height}
              onChange={(val) => {
                setProp((props) => {
                  props.height = val+"%";
                });
              }}
              label={"Height"}
            /> */}
            <OptionsInput
              label={"Alignment"}
              value={align}
              onChange={(val) => {
                setProp((props) => {
                  props.align = val;
                });
              }}
              options={[
                {
                  label: "Left",
                  value: "start",
                  icon: <LeftALignIcon width={"20px"} />,
                  active: <LeftALignActiveIcon width={"20px"} />,
                },
                {
                  label: "Center",
                  value: "center",
                  icon: <CenterAlignIcon width={"20px"} />,
                  active: <CenterAlignActiveIcon width={"20px"} />,
                },
                {
                  label: "Right",
                  value: "end",
                  icon: <RightAlignIcon width={"20px"} />,
                  active: <RightAlignActiveIcon width={"20px"} />,
                },
              ]}
            />
          </SpacerInput>
        </div>
      </>
    );
  };

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 cursor-default overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between gap-3">
          <RightBar
            title={"Twitter"}
            icon={<FontAwesomeIcon icon={faXTwitter} />}
          />
        </div>
        <div className="flex justify-between p-5 pb-0">
          <div
            className={`post-edit-menu-active w-2/6 pt-5 pb-2 text-center cursor-pointer justify-center flex flex-col items-center text-ui-dark-blue`}
            onClick={() => setIsActive("general")}
          >
            <PencilActiveIcon />
            <div className={`text-xs font-semibold`}>General</div>
          </div>
        </div>
        <div className="py-2 bg-ui-light-white"></div>
      </div>
      {isActive === "general" && General()}
    </div>
  );
};
